module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/07_Contents#pre",
      "id": "pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("The raison d’être for this book was the desire to present a representative cross section of the writings of Konrad Wolff under one cover for the benefit of students, teachers, musicians, and music lovers. The writings reflect Wolff’s roles as musicologist, teacher, and performer. Although these strands of his professional life are often finely woven together, there are many instances where one or another appears, as Debussy and Ravel at times directed in their music, "), _c('em', [_vm._v("en dehors")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The materials were gathered from various sources—music journals, radio broadcasts, lecture-recitals, class notes, his books, record liner notes, and a large correspondence, a major portion of which is housed in the Archives at the University of Maryland. Included are letters to and from well-known figures in the world of music such as Sviatoslav Richter, Artur Schnabel, Rudolf Serkin, and Alfred Brendel. Paul Badura-Skoda, in his review of Wolff’s book "), _c('em', [_vm._v("Schnabel’s Interpretation of Piano Music")]), _vm._v(", quotes a unique, elegant statement on piano playing by Edwin Fischer, who was Alfred Brendel’s teacher. In the last chapter, the culmination of an important exchange of ideas is reached in the brilliant “debate” between Wolff and Brendel.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("It should be noted that many of Wolff’s lectures—particularly the lecture-demonstrations—were given under very informal circumstances. The thought of publication at some later date probably did not occupy a place of importance in his mind, if any. Obviously, he might have wished to alter them in any number of ways; also, his ideas occasionally changed over the course of the years (as he had attested to in certain cases). Although the risks were given due consideration, the alternative of omitting important discussions seemed the greater of the two evils.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Wolff cautioned students never to lose his or her “amateur status as a music lover.” His own vast knowledge never “got in the way” "), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_vm._v("of his instinctual, elemental response to music. Indeed, the more one reads his work, the more one understands music, but perhaps of greater importance, the more one loves it.")])]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_vm._v("To distinguish it from Wolff’s own writings, the editor’s text has been italicized or set in square brackets. Musical examples inserted by the editor appear with the example numbers in square brackets. Musical examples by Wolff have no brackets around the example numbers. Underlining, unless otherwise specified, is by Wolff. Notes at the end of the book written by Wolff are so marked; all others are by the editor.")]), _vm._v(" "), _c('p', {
    staticClass: "pararight",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("R.G.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddafbb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/10_Preface.vue
// module id = 87
// module chunks = 0